<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Role">
      Role Name
      <div>
        <input
          class="form-control col-md-6"
          type="text"
          v-model="roleName"
          placeholder="Enter role name"
          @focus="roleNameEmpty = false"
        />
        <div v-if="roleNameEmpty" style="color: red">Role name is required</div>
      </div>
      <br />
      <div class="row">
        <b-form-checkbox-group
          class="col-md-4"
          v-for="(permission, index) in permissions"
          :key="index"
          v-model="selected"
          switches
          stacked
        >
          <b>{{ permission.module_type }}</b>
          <b-form-checkbox
            @change="addPermission(permissions[index].permissions[index1])"
            class="mt-4 mb-4"
            v-for="(role, index1) in permission.permissions"
            :key="index1"
            :value="permissions[index].permissions[index1].id"
            >{{
              permissions[index].permissions[index1].permission_type
            }}</b-form-checkbox
          >
        </b-form-checkbox-group>
      </div>
      <div class="text-center" v-if="selectedPermissions != ''">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="savePermissions()"
          >Save Changes</b-button
        >
      </div>
       <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader:false,
      selected: [],
      roleNameEmpty: false,
      roleName: "",
      selectedPermissions: [],
      permissions: [],
    };
  },
  mounted() {
    this.getPermissions();
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/roles/edit/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.roleName = response.data.rolewithpermission.role;
            this.selected = response.data.rolewithpermission.permissions
            this.selectedPermissions = response.data.rolewithpermission.permissions
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    addPermission(permissionData) {
      if (this.selectedPermissions.includes(permissionData.id)) {
        let index = this.selectedPermissions.indexOf(permissionData.id);
        this.selectedPermissions.splice(index, 1);
      } else {
        this.selectedPermissions.push(permissionData.id);
      }
      console.log(this.selectedPermissions);
    },

    async savePermissions() {
      this.loader = true;
      if (this.roleName == "") {
        this.roleNameEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.roleName);
      for (var i = 0; i < this.selectedPermissions.length; i++) {
        formdata.append(
          "permissions[" + i + "]",
          this.selectedPermissions[i]
        );
      }
      await axios
        .post(`${this.$store.getters.baseUrl}/roles/update/${this.$route.params.id}`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
             this.loader = false;
            this.$swal(
              "Success",
              "Permission updated for given role successfully",
              "success"
            );
            this.roleName = "";
            this.selectedPermissions = [];
            this.selected = []
            this.$router.push({ name: "Tables Role" });
          } else {
             this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
           this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getPermissions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/roles/permissions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.permissions = response.data.modules_permissions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>